import { http } from '../../config/axios'

 const findParametrop = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/parametroaplicacao/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findParametrop', error)
      throw Error(error.response.data)
    })
}

export default findParametrop;
